import axios from "axios";
import { Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import leaf from "../../Assets/Images/leaf.png";
import icon3 from "../../Assets/Images/PackagesImages/icon3.webp";
import PackageBookingModal from "../../components/UserSideComponents/packages/PackageBookingModal";
import PackageCard, { PackageCardSkeleton } from "../../components/UserSideComponents/packages/PackageCard";
import { usePackageBooking } from "../../context/PackageBookingContext";
import { useNavigate } from "react-router-dom";

const BeautyPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { openBookingModal } = usePackageBooking();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/packages`
        );
        setPackages(res.data.data || []);
      } catch (err) {
        console.error("Failed to fetch packages", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);

  return (
    <section className="bg-[#fdeee8] py-8 md:py-12 lg:py-16 px-4 sm:px-8 md:px-10 lg:px-12 mx-auto ">
      {/* Header */}
      <div className=" mx-auto mb-4 md:mb-10 flex flex-col md:flex-row justify-between items-start md:items-center gap-8 lg:gap-6">
        <div className="pb-4 md:pb-0 space-y-6 md:space-y-6 ">
          <div className="relative w-fit">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full blur opacity-20 group-hover:opacity-30 transition duration-1000 group-hover:duration-200 animate-pulse" />
            <div className="relative uppercase font-robotoflex flex items-center gap-2 sm:gap-3 border-2 border-white/30 bg-white/90 backdrop-blur-sm rounded-full text-[#ab310c] px-4 sm:px-6 py-1.5 text-sm sm:text-base tracking-wide font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 group">
              <img
                src={leaf}
                alt="leaf"
                className="w-5 h-5 sm:w-6 sm:h-6 transition-transform group-hover:rotate-12 duration-300"
              />
              <span className="bg-gradient-to-r from-[#ab310c] to-[#8a290a] bg-clip-text text-transparent">
                our packages
              </span>
              <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-amber-500 ml-1" />
            </div>
          </div>

          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-philosopher font-bold text-gray-900 leading-tight tracking-tight">
            <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
              Exclusive Beauty,&nbsp;
            </span>
            <span className="relative">
              <span className="bg-gradient-to-r from-[#ab310c] via-[#d44a20] to-[#EDB5A4] bg-clip-text text-transparent">
                Packages
              </span>
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-[#ab310c] to-[#EDB5A4] rounded-full" />
            </span>
          </h1>
        </div>

        <div className="flex flex-col  ">
          <img
            src={icon3}
            alt=""
            className="hidden md:block w-20 h-24 text-black  translate-x-24 md:translate-x-80 lg:translate-x-96 -translate-y-8 "
          />
          <div data-aos="fade-left" data-aos-delay={200}>
            <p className="-translate-y-6 font-robotoflex flex max-w-lg md:text-base text-sm text-left md:text-right md:text-[#1E1E1E] text-gray-600 leading-relaxed tracking-wide">
              Our carefully curated packages are designed to meet all your
              beauty needs in one place. From hair and skin care to complete
              grooming, each package offers expert services at great value.
            </p>
          </div>
        </div>
      </div>

      {/* Cards Grid */}
      {loading ? (
        <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 no-scrollbar sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:overflow-visible">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="min-w-[280px] snap-start sm:min-w-0">
              <PackageCardSkeleton />
            </div>
          ))}
        </div>
      ) : packages.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10 text-center">
          <div className="rounded-3xl p-10 max-w-xl w-full">
            <Sparkles className="w-12 h-12 text-orange-500 mx-auto mb-4 animate-pulse" />
            <h2 className="text-3xl font-bold text-gray-800 mb-3">
              Packages Coming Soon
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              We are preparing something amazing for you ✨ Stay tuned.
            </p>
          </div>
        </div>
      ) : (
        <>
          < div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 no-scrollbar sm:items-stretch sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:overflow-visible">
            {/* Mobile: horizontal scroll | Desktop: grid */}
            {packages
              .filter((pkg) => pkg.isActive)
              .slice(0, 8)
              .map((pkg) => (
                <div key={pkg._id} className="min-w-[300px] snap-start sm:min-w-0">
                  <PackageCard
                    pkg={pkg}
                    openBookingModal={openBookingModal}
                  />
                </div>
              ))}
          </div>
          <div className="mt-6 sm:mt-8 flex justify-center">
            <button
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                navigate("/packages");
              }}
              className="group relative px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg 
              text-sm sm:text-base font-medium tracking-wide 
              bg-[#2B1A14] hover:bg-primaryBtnHoverColor text-[#f5e8e2] 
              transition-all duration-300 
              hover:scale-105 active:scale-[0.98]"
            >
              View All

              {/* subtle glow */}
              <span className="absolute inset-0 rounded-full bg-[#9b3a1f]/20 blur opacity-0 group-hover:opacity-100 transition duration-300" />
            </button>
          </div>
        </>
      )}

      {/* The booking modal — rendered once here, opens on any card's Book Now */}
      <PackageBookingModal />
    </section>
  );
};

export default BeautyPackages;
